import { useEffect } from 'react'
import { MessageSquarePlus } from 'lucide-react'
import { commandRegistry } from '@/utils/commandRegistry'
import { useFeedbackStore } from './feedbackStore'

/**
 * Registers the "Send feedback" command into the Cmd+K palette. Mount once
 * at AppShell level; auto-unregisters on unmount.
 */
export function useFeedbackCommands() {
  useEffect(() => {
    const unregister = commandRegistry.register({
      id: 'feedback.send',
      label: 'Send feedback',
      subtitle: 'Tell us what you think',
      icon: MessageSquarePlus,
      keywords: ['feedback', 'bug', 'report', 'support', 'help'],
      action: () => useFeedbackStore.getState().open({ entryPoint: 'cmd_k' }),
      category: 'action',
      showInDefault: true,
    })

    return unregister
  }, [])
}
